// THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
// Run: sh packages/api-types/scripts/run_generate_api_types.sh

import type * as Models from '../models'
import * as Schemas from '../validators'
import { defineEndpoint } from '../endpoint'

export type FrontendRumIngestorRequest = Models.FrontendRumIngestionRequest
export type FrontendRumIngestorResponse = Models.FrontendRumIngestionResponse

export type ObservabilityBulkFailureTransitionRequest = Models.ObservabilityBulkFailureTransitionRequest
export type ObservabilityBulkFailureTransitionResponse = Models.ObservabilityBulkFailureTransitionResponse

export type ObservabilityCatalogRequest = Models.ObservabilityCatalogRequest
export type ObservabilityCatalogResponse = Models.ObservabilityCatalogResponse

export type ObservabilityCompareRequest = Models.ObservabilityCompareRequest
export type ObservabilityCompareResponse = Models.ObservabilityCompareResponse

export type ObservabilityEnvironmentHealthRequest = Models.ObservabilityEnvironmentHealthRequest
export type ObservabilityEnvironmentHealthResponse = Models.ObservabilityEnvironmentHealthResponse

export type ObservabilityFailureAcknowledgeRequest = Models.ObservabilityAcknowledgeFailureRequest
export type ObservabilityFailureAcknowledgeResponse = Models.ObservabilityAcknowledgeFailureResponse

export type ObservabilityFailureGroupsRequest = Models.ObservabilityFailureGroupsRequest
export type ObservabilityFailureGroupsResponse = Models.ObservabilityFailureGroupsResponse

export type ObservabilityFailureQueueRequest = Models.ObservabilityFailureQueueRequest
export type ObservabilityFailureQueueResponse = Models.ObservabilityFailureQueueResponse

export type ObservabilityFailureTransitionRequest = Models.ObservabilityFailureTransitionRequest
export type ObservabilityFailureTransitionResponse = Models.ObservabilityFailureTransitionResponse

export type ObservabilityLogLookupRequest = Models.ObservabilityLogLookupRequest
export type ObservabilityLogLookupResponse = Models.ObservabilityLogLookupResponse

export type ObservabilityQuerySummaryRequest = Models.ObservabilitySummaryRequest
export type ObservabilityQuerySummaryResponse = Models.ObservabilitySummaryResponse

export type ObservabilityRunDetailRequest = Models.ObservabilityRunDetailRequest
export type ObservabilityRunDetailResponse = Models.ObservabilityRunDetailResponse

export type ObservabilityRunSearchRequest = Models.ObservabilityRunSearchRequest
export type ObservabilityRunSearchResponse = Models.ObservabilityRunSearchResponse

export type ObservabilityServiceDetailRequest = Models.ObservabilityServiceDetailRequest
export type ObservabilityServiceDetailResponse = Models.ObservabilityServiceDetailResponse

export type ObservabilityServiceInventoryRequest = Models.ObservabilityServiceInventoryRequest
export type ObservabilityServiceInventoryResponse = Models.ObservabilityServiceInventoryResponse

export type ObservabilitySessionDetailRequest = Models.ObservabilityRumSessionDetailRequest
export type ObservabilitySessionDetailResponse = Models.ObservabilityRumSessionDetailResponse

export type ObservabilitySessionSearchRequest = Models.ObservabilityRumSessionSearchRequest
export type ObservabilitySessionSearchResponse = Models.ObservabilityRumSessionSearchResponse

export type ObservabilityUsageInventoryRequest = Models.ObservabilityUsageInventoryRequest
export type ObservabilityUsageInventoryResponse = Models.ObservabilityUsageInventoryResponse

export type ObservabilityUsageSubjectRequest = Models.ObservabilityUsageSubjectRequest
export type ObservabilityUsageSubjectResponse = Models.ObservabilityUsageSubjectResponse

export type ObservabilityUserAccessListRequest = Models.ObservabilityUserAccessListRequest
export type ObservabilityUserAccessListResponse = Models.ObservabilityUserAccessListResponse

export type ObservabilityUserAccessUpdateRequest = Models.ObservabilityUserAccessUpdateRequest
export type ObservabilityUserAccessUpdateResponse = Models.ObservabilityUserAccessUpdateResponse

export const endpoints = {
  frontendRumIngestor: defineEndpoint<FrontendRumIngestorRequest, FrontendRumIngestorResponse>({
    path: 'observability/rum',
    method: 'POST',
    responseSchema: Schemas.FrontendRumIngestionResponseSchema,
  }),
  observabilityBulkFailureTransition: defineEndpoint<ObservabilityBulkFailureTransitionRequest, ObservabilityBulkFailureTransitionResponse>({
    path: 'observability/query/failure-transition-bulk',
    method: 'POST',
    responseSchema: Schemas.ObservabilityBulkFailureTransitionResponseSchema,
  }),
  observabilityCatalog: defineEndpoint<ObservabilityCatalogRequest, ObservabilityCatalogResponse>({
    path: 'observability/query/catalog',
    method: 'POST',
    responseSchema: Schemas.ObservabilityCatalogResponseSchema,
  }),
  observabilityCompare: defineEndpoint<ObservabilityCompareRequest, ObservabilityCompareResponse>({
    path: 'observability/query/compare',
    method: 'POST',
    responseSchema: Schemas.ObservabilityCompareResponseSchema,
  }),
  observabilityEnvironmentHealth: defineEndpoint<ObservabilityEnvironmentHealthRequest, ObservabilityEnvironmentHealthResponse>({
    path: 'observability/query/environment-health',
    method: 'POST',
    responseSchema: Schemas.ObservabilityEnvironmentHealthResponseSchema,
  }),
  observabilityFailureAcknowledge: defineEndpoint<ObservabilityFailureAcknowledgeRequest, ObservabilityFailureAcknowledgeResponse>({
    path: 'observability/query/failure-acknowledge',
    method: 'POST',
    responseSchema: Schemas.ObservabilityAcknowledgeFailureResponseSchema,
  }),
  observabilityFailureGroups: defineEndpoint<ObservabilityFailureGroupsRequest, ObservabilityFailureGroupsResponse>({
    path: 'observability/query/failure-groups',
    method: 'POST',
    responseSchema: Schemas.ObservabilityFailureGroupsResponseSchema,
  }),
  observabilityFailureQueue: defineEndpoint<ObservabilityFailureQueueRequest, ObservabilityFailureQueueResponse>({
    path: 'observability/query/failure-queue',
    method: 'POST',
    responseSchema: Schemas.ObservabilityFailureQueueResponseSchema,
  }),
  observabilityFailureTransition: defineEndpoint<ObservabilityFailureTransitionRequest, ObservabilityFailureTransitionResponse>({
    path: 'observability/query/failure-transition',
    method: 'POST',
    responseSchema: Schemas.ObservabilityFailureTransitionResponseSchema,
  }),
  observabilityLogLookup: defineEndpoint<ObservabilityLogLookupRequest, ObservabilityLogLookupResponse>({
    path: 'observability/logs',
    method: 'POST',
    responseSchema: Schemas.ObservabilityLogLookupResponseSchema,
  }),
  observabilityQuerySummary: defineEndpoint<ObservabilityQuerySummaryRequest, ObservabilityQuerySummaryResponse>({
    path: 'observability/query/summary',
    method: 'POST',
    responseSchema: Schemas.ObservabilitySummaryResponseSchema,
  }),
  observabilityRunDetail: defineEndpoint<ObservabilityRunDetailRequest, ObservabilityRunDetailResponse>({
    path: 'observability/query/run-detail',
    method: 'POST',
    responseSchema: Schemas.ObservabilityRunDetailResponseSchema,
  }),
  observabilityRunSearch: defineEndpoint<ObservabilityRunSearchRequest, ObservabilityRunSearchResponse>({
    path: 'observability/query/run-search',
    method: 'POST',
    responseSchema: Schemas.ObservabilityRunSearchResponseSchema,
  }),
  observabilityServiceDetail: defineEndpoint<ObservabilityServiceDetailRequest, ObservabilityServiceDetailResponse>({
    path: 'observability/query/service-detail',
    method: 'POST',
    responseSchema: Schemas.ObservabilityServiceDetailResponseSchema,
  }),
  observabilityServiceInventory: defineEndpoint<ObservabilityServiceInventoryRequest, ObservabilityServiceInventoryResponse>({
    path: 'observability/query/services',
    method: 'POST',
    responseSchema: Schemas.ObservabilityServiceInventoryResponseSchema,
  }),
  observabilitySessionDetail: defineEndpoint<ObservabilitySessionDetailRequest, ObservabilitySessionDetailResponse>({
    path: 'observability/query/session-detail',
    method: 'POST',
    responseSchema: Schemas.ObservabilityRumSessionDetailResponseSchema,
  }),
  observabilitySessionSearch: defineEndpoint<ObservabilitySessionSearchRequest, ObservabilitySessionSearchResponse>({
    path: 'observability/query/session-search',
    method: 'POST',
    responseSchema: Schemas.ObservabilityRumSessionSearchResponseSchema,
  }),
  observabilityUsageInventory: defineEndpoint<ObservabilityUsageInventoryRequest, ObservabilityUsageInventoryResponse>({
    path: 'observability/query/usage-inventory',
    method: 'POST',
    responseSchema: Schemas.ObservabilityUsageInventoryResponseSchema,
  }),
  observabilityUsageSubject: defineEndpoint<ObservabilityUsageSubjectRequest, ObservabilityUsageSubjectResponse>({
    path: 'observability/query/usage-subject',
    method: 'POST',
    responseSchema: Schemas.ObservabilityUsageSubjectResponseSchema,
  }),
  observabilityUserAccessList: defineEndpoint<ObservabilityUserAccessListRequest, ObservabilityUserAccessListResponse>({
    path: 'observability/users/list',
    method: 'POST',
    responseSchema: Schemas.ObservabilityUserAccessListResponseSchema,
  }),
  observabilityUserAccessUpdate: defineEndpoint<ObservabilityUserAccessUpdateRequest, ObservabilityUserAccessUpdateResponse>({
    path: 'observability/users/access',
    method: 'POST',
    responseSchema: Schemas.ObservabilityUserAccessUpdateResponseSchema,
  }),
} as const
